import magnifiAPIInstance from "./apiInstance";
export const planAPIs = {
  getPlans: () => magnifiAPIInstance.get("/plans/get"),
  addPlan: ({ payload }) => magnifiAPIInstance.post("/plans/create", payload),
  modifyPlan: ({ payload }) => magnifiAPIInstance.patch("/plans/update", payload),
  deletePlan: ({ payload }) => magnifiAPIInstance.delete(`/plan/delete/${payload.planId}`, payload),
};
